import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Config from '../../../../../Config';
import Property from '@episerver/spa-core/Components/Property';


const Complete = (props) => {

    const getDate = () => {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();

        today = dd + '.' + mm + '.' + yyyy;
        return today;
    }

    let fullName = props.userDetails.firstName + ' ' + props.userDetails.lastName;
    let IDNumber = props.userDetails.IDNumber;

    return (
        <div className='complete-container'>

          {props.isPinTechnician || props.movingWithTechnician ?
              <>
                  <div className='complete-title'>מעולה, ניפגש!</div>
                  <div className='complete-fixDate'>קבענו ליום {props.fullDate}</div>
                  <div className='complete-address'>{props.fullAddress}</div>
              </>
              :
              <div className='complete-title'>עדכון הכתובת בוצע בהצלחה!</div>
          }

            {/* <div className='complete-pink-block'>
                <span><b>שם הלקוח: </b>{fullName}</span>
                <span>
                    <b>תאריך: </b> {getDate()} | <b>תעודת זהות: </b> {IDNumber}
                </span>
            </div> */}
        </div>
    );
};
const mapStateToProps = (state) => {
    return {
        page: state.movingBlock.page,
        movingWithTechnician: state.movingBlock.movingApartmentData.movingWithTechnician,
        fullDate: state.movingBlock.movingApartmentData.technicianData.selectedTechnicianTimeSlot.fullDate,
    };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Complete);
